export enum BfxPopupNotificationCommand {
  // GENERAL
  POPUP_CLOSE,
  // FOOTER COMMANDS
  POPUP_VIEW_ORDER,
  POPUP_VIEW_DEAL,
  POPUP_VIEW_DI_DETAILS,
  // TRIGGER
  POPUP_QUICK_FILL,
  POPUP_DETAIL_FILL,
  POPUP_REACTIVATE,
  // ACCEPTANCE
  POPUP_DI_ACCEPT,
  POPUP_DI_ACCEPT_INTO,
  POPUP_DI_ACCEPT_TOPSIDE,
  POPUP_DI_ACCEPT_DOWNSIDE,
  POPUP_DI_REJECT,
  //INTERVENTION
  POPUP_INTERVENTION_APPROVE,
  POPUP_INTERVENTION_REJECT,
  POPUP_INTERVENTION_TRADER_ACCEPT,
  POPUP_INTERVENTION_TRADER_REJECT,
  POPUP_INTERVENTION_CANCEL,
  //INFLIGHT
  POPUP_INFLIGHT_ORDER,
  POPUP_POSITION,
  POPUP_POSITION_REVERT,
  POPUP_VIEW_OPS,
  POPUP_VIEW_DI_PRICE,
  POPUP_VIEW_DEALER_INTERVENTION,
}
